const STORAGE_KEY = 'enabledLogAnalytics';

type GAEvent = {
  event: string;
  params: unknown;
};

/**
 * Send events to analytics
 * @class
 * @public
 */

class AnalyticsUtils {
  hasFlagLogAnalytics: string | null = null;

  hasGTMLoaded = false;

  private eventsQueue: GAEvent[] = [];

  constructor() {
    if (!__IS_SERVER__) {
      this.hasFlagLogAnalytics = localStorage.getItem(STORAGE_KEY);
      if (!this.hasFlagLogAnalytics) {
        localStorage.setItem(STORAGE_KEY, '');
      }

      window.dataLayer = window.dataLayer ?? [];
      this.hasGTMLoaded = !!window.dataLayer.find(eventObj => eventObj.event === 'gtm.load');

      if (!this.hasGTMLoaded) {
        const resolveEvents = () => {
          this.hasGTMLoaded = true;
          this.eventsQueue.forEach(({ event, params }) => this.sendEvent(event, params));
        };

        const originalPush = window.dataLayer.push;
        window.dataLayer.push = function push(...args) {
          if (args[0].event === 'gtm.load') resolveEvents();
          return originalPush.apply(this, args);
        };
      }
    }
  }

  /**
   * Send event with params
   * @param {string} event name of event
   * @param {*} params any data
   * @public
   */

  public sendEvent(event: string, params: unknown) {
    if (!!this.hasFlagLogAnalytics && this.hasGTMLoaded) {
      // eslint-disable-next-line no-console
      console.log(event, params);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.hasGTMLoaded
      ? document.dispatchEvent(new CustomEvent(event, { detail: params }))
      : this.eventsQueue.push({ event, params });
  }
}

export const analyticsUtils = new AnalyticsUtils();
